import React from 'react';

const Terms: React.FC = () => {
  return (
    <div className="blueprint-grid min-h-screen bg-white">
      {/* Simple Header */}
      <div className="border-b border-black/[0.08] py-12">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <span className="eyebrow">Legal</span>
          <h1 className="mt-2 font-serif text-4xl tracking-tight text-charcoal md:text-5xl">Terms of Service</h1>
          <p className="mt-3 font-mono text-xs text-ink-muted">Last updated: October 22, 2025</p>
        </div>
      </div>

      {/* Content */}
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="card-frame p-8 md:p-12">
          <div className="prose prose-lg max-w-none text-gray-700 space-y-8">
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                1. Acceptance of Terms
              </h2>
              <p className="leading-relaxed">
                By accessing and using Steelman, you accept and agree to be bound by the terms and provision of this 
                agreement. If you do not agree to these Terms of Service, please do not use our service.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                2. Description of Service
              </h2>
              <p className="leading-relaxed">
                Steelman provides an AI-powered debate platform that generates arguments on multiple sides of topics 
                submitted by users. The service is provided "as is" and "as available."
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                3. User Accounts
              </h2>
              <p className="leading-relaxed">
                You are responsible for maintaining the confidentiality of your account and password. You agree to 
                accept responsibility for all activities that occur under your account.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                4. User Conduct
              </h2>
              <p className="leading-relaxed mb-3">
                You agree not to use the service to:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Violate any applicable laws or regulations</li>
                <li>Post content that is illegal, harmful, threatening, abusive, harassing, or otherwise objectionable</li>
                <li>Impersonate any person or entity</li>
                <li>Interfere with or disrupt the service or servers</li>
                <li>Attempt to gain unauthorized access to any portion of the service</li>
              </ul>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                5. Content Moderation
              </h2>
              <p className="leading-relaxed">
                We employ automated content moderation to ensure debates remain civil and constructive. We reserve 
                the right to remove content or suspend accounts that violate our community standards.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                6. AI-Generated Content
              </h2>
              <p className="leading-relaxed">
                All debate arguments are generated by AI. While we strive for accuracy and quality, the content may 
                contain errors or biases. Users should verify important information from authoritative sources.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                7. Intellectual Property
              </h2>
              <p className="leading-relaxed">
                The service and its original content, features, and functionality are owned by Steelman and are 
                protected by international copyright, trademark, and other intellectual property laws.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                8. Subscription and Payments
              </h2>
              <p className="leading-relaxed">
                Some features require a paid subscription. Subscription fees are billed in advance on a recurring 
                basis. You may cancel your subscription at any time.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                9. Limitation of Liability
              </h2>
              <p className="leading-relaxed">
                In no event shall Steelman be liable for any indirect, incidental, special, consequential, or 
                punitive damages resulting from your use of or inability to use the service.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                10. Changes to Terms
              </h2>
              <p className="leading-relaxed">
                We reserve the right to modify these terms at any time. We will notify users of any material changes 
                via email or through the service.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-serif font-bold text-charcoal mb-4 pb-2 border-b border-gray-200">
                11. Contact
              </h2>
              <p className="leading-relaxed">
                For questions about these Terms of Service, please contact us on{' '}
                <a 
                  href="https://x.com/steelman_ai" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-steel-blue hover:text-steel-blue-dark font-semibold transition-colors"
                >
                  X/Twitter @steelman_ai
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;

